import React, { useState } from "react";
import { AccountData, Event, TicketV2 } from "@markit/common.types";
import ProfilePreviewModal from "./ProfilePreviewModal";
import ConversationsSidebarModal from "../CreatorDashboard/Conversations/ConversationsSidebarModal";
import { FormResponsesModal } from "../EventDashboard/DashboardModals/FormResponsesModal";

interface FullProfilePreviewModalProps {
  profileSelected: AccountData | undefined;
  setProfileSelected: (profileSelected: AccountData | undefined) => void;
  event?: Event;
  userTicket?: TicketV2;
}

// Handles the ProfilePreviewModal but also the ConversationsSidebarModal in conjunction
const FullProfilePreviewModal = (props: FullProfilePreviewModalProps) => {
  const { profileSelected, setProfileSelected, event, userTicket } = props;
  const [hideProfilePreview, setHideProfilePreview] = useState(false);
  const [fullProfileOpen, setFullProfileOpen] = useState(false);
  const [conversationUser, setConversationUser] = useState<AccountData>();
  const [isUserResponseModalOpen, setIsUserResponseModalOpen] =
    useState<boolean>(false);

  return (
    <>
      {profileSelected ? (
        isUserResponseModalOpen && event ? (
          <FormResponsesModal
            event={event}
            profileData={profileSelected}
            setIsVisible={setIsUserResponseModalOpen}
          />
        ) : (
          <ProfilePreviewModal
            userData={profileSelected}
            event={event}
            userTicket={userTicket}
            setProfileSelected={setProfileSelected}
            setProfileResponseModalOpen={setIsUserResponseModalOpen}
            messageOnPress={(item) => setConversationUser(item)}
            hideProfilePreview={hideProfilePreview}
            setHideProfilePreview={setHideProfilePreview}
            fullProfileOpen={fullProfileOpen}
            setFullProfileOpen={setFullProfileOpen}
          />
        )
      ) : null}
      {conversationUser ? (
        <ConversationsSidebarModal
          conversationUser={conversationUser}
          setConversationUser={setConversationUser}
          reopenProfilePreview={() =>
            hideProfilePreview && !fullProfileOpen
              ? setHideProfilePreview(false)
              : null
          }
          fullProfileOpen={fullProfileOpen}
        />
      ) : null}
    </>
  );
};

export default FullProfilePreviewModal;
